import { makeStyles, tokens } from "@microsoft/shifts-ui-core";

export const useStyles = makeStyles({
    header: {
        padding: tokens.spacingVerticalXL,
        paddingBottom: tokens.spacingVerticalM,
        borderBottomWidth: "0.0625rem",
        borderBottomStyle: "solid",
        borderBottomColor: tokens.colorNeutralStroke2
    },
    body: {
        paddingLeft: tokens.spacingHorizontalXXXL,
        paddingRight: tokens.spacingHorizontalXXXL,
        paddingTop: tokens.spacingVerticalXL,
        height: "calc(100vh - 3.75rem)" // Account for header height
    },
    content: {
        display: "grid",
        gridTemplateColumns: "1fr auto",
        rowGap: tokens.spacingVerticalM,
        columnGap: tokens.spacingHorizontalS,
        width: "100%"
    },
    ruleLabel: {
        color: tokens.colorNeutralForeground2
    },
    ruleValue: {
        color: tokens.colorNeutralForeground1,
        fontWeight: tokens.fontWeightMedium,
        textAlign: "right"
    },
    noConstraints: {
        gridColumn: "1 / -1",
        textAlign: "center",
        color: tokens.colorNeutralForeground2,
        fontStyle: "italic",
        padding: tokens.spacingVerticalL
    },
    navigateButton: {
        marginTop: tokens.spacingVerticalXL
    }
});